import useColumnsOrdersStore from "@/modules/sales/home/store/useColumnsOrdersStore";
import { usePurchasingStore } from "@store/purchases/addPurchase/usePurchasingStore";
import { create } from "zustand";

const useAuthStore = create((set) => {
  let storedToken = null;
  let storedUser = null;
  let storedExpiresIn = null;
  let storedPermissions = [];
  if (typeof window !== "undefined") {
    storedToken = localStorage.getItem("token");
    storedExpiresIn = localStorage.getItem("expiresIn");
    storedUser = localStorage.getItem("user");
    storedPermissions = localStorage.getItem("permissions");
    storedUser =
      typeof storedUser === "string" && storedUser.trim() !== ""
        ? JSON.parse(storedUser)
        : null;
    storedPermissions = storedPermissions ? JSON.parse(storedPermissions) : [];
  }
  return {
    token: storedToken || null,
    user: storedUser,
    permissions: storedPermissions,
    expiresIn: storedExpiresIn || null,
    showSessionExpiredModal: false,
    setShowSessionExpiredModal: (value) =>
      set({ showSessionExpiredModal: value }),
    setAuthData: (expiresIn, token, permissions, newUser) => {
      set({
        expiresIn: expiresIn,
        token: token,
        permissions: permissions,
        user: newUser,
      });
      if (typeof window !== "undefined") {
        localStorage.setItem("tokenTimestamp", Date.now().toString());
        localStorage.setItem("expiresIn", expiresIn);
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(newUser));
        localStorage.setItem("permissions", JSON.stringify(permissions));
      }
    },
    clearAuthData: () => {
      const { setOrders, setEditableRows } = usePurchasingStore.getState();
      const { resetHiddenColumns } = useColumnsOrdersStore.getState();

      setOrders([]);
      setEditableRows({});
      resetHiddenColumns();

      set({ token: null, permissions: [], user: null, expiresIn: null });
      if (typeof window !== "undefined") {
        localStorage.removeItem("token");
        localStorage.removeItem("expiresIn");
        localStorage.removeItem("tokenTimestamp");
        localStorage.removeItem("user");
        localStorage.removeItem("permissions");
        localStorage.removeItem("purchasing-store");
        localStorage.removeItem("ordersHiddenColumns");
        setOrders([]);
        setEditableRows({});
      }
    },
    clearPermissions: () => {
      set({ permissions: [] });
      if (typeof window !== "undefined") {
        localStorage.removeItem("permissions");
      }
    },
  };
});
export default useAuthStore;
